import {
  NudosHoverText,
  NudosMaskedNumberInput,
  NudosTextInput
} from '../../../../../../../../../../components/NudosComponents';
import NudosProductPills from '../../../../../../../../../../components/NudosComponents/NudosProductPills/NudosProductPills';
import useStockOrdersModuleState from '../../../../../../../../../../state/useStockOrdersModuleState';
import { IpillsByReference } from '../../../../../../../../../../types/orders';
import { IProductReference } from '../../../../../../../../../../types/services';
import './SingleProductCard.scss';

const SingleProductCard = ({
  product,
  removeProductCallback
}: {
  product: IProductReference;
  removeProductCallback: () => void;
}) => {
  const { selectedProducts, updateProductData, searchWarehouse } = useStockOrdersModuleState();
  const productData = selectedProducts.find(p => p?.id === product?.id);

  const formattedPills =
    typeof product?.pills === 'string' ? (JSON.parse(product?.pills) as IpillsByReference) : product?.pills || {};
  return (
    <div className="singleProductCard">
      <div key={product?.id} className="selectedProductCard">
        <div className="productInfo">
          <div className="flex items-center gap-8">
            <div className="productName">
              <NudosHoverText text={product?.name} charactersLimit={40} onlyIfTruncated maxHoverWidth="300px" />
            </div>
            <NudosProductPills pills={formattedPills} characterLimit={6} />
          </div>
          <div className="productSku">SKU: {product?.sku}</div>
        </div>
        <div className="flex items-center gap-8">
          <div className="flex items-center gap-8">
            <NudosTextInput
              label="Unidad"
              placeholder="Unidad"
              isFilled
              componentSize="extraSmall"
              defaultValue={productData?.quantity ? productData.quantity.toString() : undefined}
              handleChange={value => updateProductData(product?.id, { quantity: Number(value) })}
            />
            <NudosMaskedNumberInput
              label="Costo con IVA"
              currentValue={String(productData?.taxCost || 0)}
              isFilled
              isDeactivated={false}
              placeholder=""
              componentSize="small-184"
              maskPrefix="$"
              maskSufix={` ${searchWarehouse?.currencyCode}`}
              numberOfDecimals={2}
              handleChange={value => {
                const numericValue = value && value.trim() !== '' ? Number(value) : 0;
                updateProductData(product?.id, { taxCost: isNaN(numericValue) ? 0 : numericValue });
              }}
            />
            <NudosMaskedNumberInput
              label="Subtotal"
              currentValue={String(productData?.subtotal ?? 0)}
              isFilled
              isDeactivated
              placeholder=""
              componentSize="small-184"
              maskPrefix="$"
              maskSufix={` ${searchWarehouse?.currencyCode}`}
              numberOfDecimals={2}
              handleChange={value => updateProductData(product?.id, { subtotal: Number(value) })}
            />
          </div>
          <button onClick={removeProductCallback} className="removeButton">
            Eliminar
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleProductCard;
